
const productosPertina = [
    
    {
        id: 1,
        nombre: 'Infinity',
        colores: ['Sunset','Luvina','Serenity'],
        categoria:'Pertina',
        peso:'175 g/ m2 + - 5%',
        images: [
            require ('../../assets/img/productos/pertina/pertinaInfinity/muestra.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaInfinity/2.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaInfinity/3.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaInfinity/4.jpg')
        ]
    },{
        id: 2,
        nombre: 'Dimmer',
        colores: ['Perla','Citrino','Onix'],
        categoria:'Pertina',
        peso:'235 g/ m2 + - 5%',
        images: [
            require ('../../assets/img/productos/pertina/pertinaDimmer/muestra.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaDimmer/2.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaDimmer/3.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaDimmer/4.jpg')
        ]
    },{
        id: 3,
        nombre: 'Rocks',
        colores: ['Cuarzo','Cantera','Agata'],
        categoria:'Pertina',
        peso:'195 g/ m2 + - 5%',
        images: [
            require ('../../assets/img/productos/pertina/pertinaRocks/muestra.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaRocks/1.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaRocks/2.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaRocks/3.jpg')
        ]
    }
].map(producto => ({
    ...producto,
    medidas: '5.80 x 6.00 m (Medidas máximas sugeridas)',
    boloqueo: 'Alto grado de privacidad',
    composicion: '100% Poliéster',
    slug:producto.nombre.toLowerCase().replace(/\s+/g, '-'),
    categoriaSlug: producto.categoria.toLowerCase().replace(/\s+/g, '-')
  }));
export default productosPertina;